import React from "react";
import SectionLayoutWrapper from "./SectionLayoutWrapper";
import { NavigationBase } from "@reusejs/react";
import Logo from "./header/Logo";
import Link from "next/link";

export default function SectionLayout(props: any) {
  return (
    <>
      <SectionLayoutWrapper
        firstChild={
          <>
            <NavigationBase
              left={Logo}
              right={() => {
                return (
                  <>
                    <div className="hidden lg:block w-auto text-blue-600 text-sm font-semibold">
                      <Link href="/">
                        <a>{`< Go to home page`}</a>
                      </Link>
                    </div>
                    <div className="lg:hidden"></div>
                  </>
                );
              }}
              backgroundClasses="bg-white"
              widthClasses="mx-auto max-w-7xl px-4 sm:px-6 lg:px-20"
            />
            <div className="flex-col flex justify-center w-full">
              {props.firstChild}
            </div>
            <NavigationBase
              left={() => {
                return (
                  <div className="w-auto text-xxs md:text-xs">
                    © Auction bazaar UI 2022
                  </div>
                );
              }}
              right={() => {
                return (
                  <div className="w-auto text-xxs md:text-xs">
                    contact@auctionbazaar.com
                  </div>
                );
              }}
              backgroundClasses="bg-white"
              widthClasses="mx-auto max-w-7xl px-4 sm:px-6 lg:px-20"
              borderClasses=""
            />
          </>
        }
        secondChild={props.secondChild}
      />
    </>
  );
}
